const $ = window.$;



export default class Sns {
  constructor() {
    this.state = {
      collapse: true,
    }

  }


}
$(function(){
  var w = $(window).width();
  var shareBtn = $('.sns-share');
  if(w > 980) {
    $('.footer-sns').on({
      'mouseenter':function(){
        shareBtn.fadeIn();
      },
      'mouseleave':function(){
        shareBtn.fadeOut();
      }
    });
  } else {
    $('.footer-sns').on('click', function(){
      if(shareBtn.hasClass('is-active')) {
        shareBtn.removeClass('is-active').fadeOut();
      } else {
        shareBtn.addClass('is-active').fadeIn();
      }
    });
  }
});



/** WEBPACK FOOTER **
 ** ./htdocs_dev/js/utill/sns.js
 **/